<template>
  <div>
    <h1 class="subtitle">Consulta de Precios</h1>
    <hr>
    <div class="columns">
      <div class="column is-3">
        <b-field>
          <b-input size="is-small" placeholder="Buscar Descripción" v-model="descripcion"></b-input>
        </b-field>
      </div>
      <div class="column is-2">
        <b-button type="is-info" size="is-small" @click="search">Buscar</b-button>
      </div>
    </div>
    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
      <thead>
      <tr>
        <th>Producto</th>
        <th>Unidad</th>
        <th>Cantidad</th>
        <th>Proveedor</th>
        <th>Fecha de Compra</th>
        <th>Marca</th>
        <th>Precio</th>
        <th>Centro de Costo</th>
        <th>Observación</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in ordenes" :key="index">
          <td>{{item.descripcion}}</td>
          <td>{{item.unidad.simbolo}}</td>
          <td>{{item.cantidad}}</td>
          <td>{{item.orden.proveedor.razon_social}}</td>
          <td>{{item.orden.fecha_orden}}</td>
          <td>{{item.marca.id_marca === 0 ? '-':item.marca.descripcion}}</td>
          <td>{{item.precio_unitario | amount}}</td>
          <td>{{item.orden.centro_costo.codigo}} {{item.orden.centro_costo.descripcion}}</td>
          <td>{{item.orden.observacion}}</td>
          <th>
            <a :href="'/orden/view/' + item.orden.id_orden" title="Información"
               target="_blank"
            ><span class="icon has-text-info">
              <i class="mdi mdi-information mdi-18px"></i> </span
            ></a>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: "PriceSearch",
    data(){
      return {
        ordenes:[],
        descripcion:''
      }
    },
    methods:{
      search(){
        axios.post('/orden/item/search',{search:this.descripcion}).then(
          resp => this.ordenes = resp.data
        )
      }
    }
  }
</script>

<style scoped>

</style>
